import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthForm } from "@/components/AuthForm";
import { supabase } from "@/integrations/supabase/client";

export function Auth() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const userType = searchParams.get('type') as 'customer' | 'tradesman' | null;
  const redirectTo = searchParams.get('redirect');
  const safeRedirect = redirectTo && redirectTo.startsWith('/') ? redirectTo : '/';

  useEffect(() => {
    // Check if user is already authenticated
    const checkAuth = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        navigate(safeRedirect);
      }
    };
    
    checkAuth();
  }, [navigate, safeRedirect]);

  const handleAuthSuccess = () => {
    navigate(safeRedirect);
  };


  return (
    <AuthForm 
      onSuccess={handleAuthSuccess} 
      defaultUserType={userType || "customer"}
    />
  );
}